export const MOVEMENT_TYPES_ACCOUNT = {
  INCREASE: 'increase',
  DECREASE: 'decrease',
};
